export default __webpack_public_path__ + "static/media/rambouillet25.2d58f7aa.jpg";